<ng-dialog-header [title]="data?.title || 'Notes'"></ng-dialog-header>
<mat-dialog-content>
  <ng-container *ngTemplateOutlet="data.type && data.type === 'Help' ? helpTpl: notesTpl"></ng-container>
</mat-dialog-content>
<ng-dialog-footer>
  <div class="d-flex justify-content-end w-100" dialog-actions>
    <button mat-flat-button mat-dialog-close color="accent" aria-label="OK Notes Dialog Button">OK</button>
  </div>
</ng-dialog-footer>
<ng-template #notesTpl>
  <mat-list>
    <mat-list-item *ngFor="let note of data?.description; last as isLast;">{{ note }}
      <mat-divider *ngIf="!isLast"></mat-divider>
    </mat-list-item>
    <mat-list-item *ngFor="let note of data?.locations; last as isLast;">{{ note.name + ' - ' + note.code }}
      <mat-divider *ngIf="!isLast"></mat-divider>
    </mat-list-item>
  </mat-list>
</ng-template>
<ng-template #helpTpl>
  <h3>Invoice #:</h3>
  <ul>
    <li>Enter the 10 digit Freight Bill or Summary Bill number.</li>
    <li>An error message will display if the number entered is not exactly 10 digits.</li>
  </ul>
  <h3>Draft #:</h3>
  <ul>
    <li>Enter the 8 digit draft number.</li>
    <li>An error message will display if the number entered is not exactly 8 digits.</li>
  </ul>
  <h3>Lead Equipment:</h3>
  <ul>
    <li>Enter the 4 character equipment initials and the 6 digit equipment number without a space between them.</li>
    <li>If the equipment has less than 4 initials, you do not need to enter extra spaces.</li>
    <li>If the equipment number begins with one or more zeroes, you do not need to enter the zeroes.</li>
    <li>An error message will display if the value entered is more than 10 characters.</li>
  </ul>
  <h3>Bill of Lading:</h3>
  <ul>
    <li>Up to ten values can be entered, separated by a comma.</li>
    <li>Each value must be 16 characters or less.</li>
    <li>An error message will display if any of the values entered is more than 16 characters.</li>
  </ul>
  <h3>Permit #:</h3>
  <ul>
    <li>Up to ten values can be entered, separated by a comma.</li>
    <li>Each value must be 10 characters.</li>
    <li>An error message will display if any of the values entered is not exactly 10 characters.</li>
  </ul>
  <h3>Waybill #:</h3>
  <ul>
    <li>Up to ten values can be entered, separated by a comma.</li>
    <li>Each value must be 6 characters.</li>
    <li>An error message will display if any of the values entered is not exactly 6 characters.</li>
  </ul>
  <div *ngIf="data.isAdmin">
    <h3>Natl Acct #:</h3>
    <ul>
      <li>Enter the 6 digit Primary Six number.</li>
      <li>An error message will display if the number entered is not exactly 6 digits.</li>
    </ul>
    <h3>Customer:</h3>
    <ul>
      <li>Enter all or part of the Customer Name.</li>
      <li>An error message will display if the value entered is not at least 3 characters.</li>
    </ul>
    <h3>Team-Aud Code:</h3>
    <ul>
      <li>Enter the 3 character Team/Auditor code.</li>
      <li>An error message will display if the value entered is not exactly 3 characters.</li>
    </ul>
    <h3>Email Address:</h3>
    <ul>
      <li>Enter the email address in the format nnn@nnn.nnn.</li>
      <li>May contain a wildcard (%) character, but only before the @.</li>
      <li>Must contain at least one character other than the wildcard before the @.</li>
      <li>An error message will display if more than one address is entered or the format is not correct.</li>
    </ul>
  </div>
</ng-template>
